export const HR_WELFARE_FUND_PERMISSION_CODES = {
    WEB_HR_WELFARE_FUND_LIST: 'WEB_HR_WELFARE_FUND_LIST',
    WEB_HR_WELFARE_FUND_DETAIL: 'WEB_HR_WELFARE_FUND_DETAIL',
    WEB_HR_WELFARE_FUND_ADD: 'WEB_HR_WELFARE_FUND_ADD',
    WEB_HR_WELFARE_FUND_EDIT: 'WEB_HR_WELFARE_FUND_EDIT',
    WEB_HR_WELFARE_FUND_DELETE: 'WEB_HR_WELFARE_FUND_DELETE',
    WEB_HR_WELFARE_FUND_IMPORT: 'WEB_HR_WELFARE_FUND_IMPORT',
    WEB_HR_WELFARE_FUND_EXPORT: 'WEB_HR_WELFARE_FUND_EXPORT',
} as const;

